// frontend/src/theme/theme-color-presets.js
import { alpha } from '@mui/material/styles';

// Theme color presets with your brand colors
export const presets = [
  // CARO PLUM
  {
    name: 'plum',
    primary: {
      lighter: '#E7D6E0',
      light: '#C87DA1',
      main: '#9A3F69',
      dark: '#702C4D',
      darker: '#4A1C33',
      contrastText: '#FFFFFF',
    },
  },
  // CARO GOLD
  {
    name: 'gold',
    primary: {
      lighter: '#F6EDD0',
      light: '#E7C87B',
      main: '#DAA03D',
      dark: '#B5842F',
      darker: '#78561F',
      contrastText: '#000000',
    },
  },
  // DEFAULT (BLUE)
  {
    name: 'default',
    primary: {
      lighter: '#D1E9FC',
      light: '#76B0F1',
      main: '#1976D2',
      dark: '#103996',
      darker: '#061B64',
      contrastText: '#FFFFFF',
    },
  },
  // PURPLE
  {
    name: 'purple',
    primary: {
      lighter: '#EBD6FD',
      light: '#B985F4',
      main: '#7635DC',
      dark: '#431A9E',
      darker: '#200A69',
      contrastText: '#FFFFFF',
    },
  },
  // GREEN
  {
    name: 'green',
    primary: {
      lighter: '#C8FAD6',
      light: '#5BE49B',
      main: '#00A76F',
      dark: '#007867',
      darker: '#004B50',
      contrastText: '#FFFFFF',
    },
  },
  // ORANGE
  {
    name: 'orange',
    primary: {
      lighter: '#FEF4D4',
      light: '#FED680',
      main: '#FDA92C',
      dark: '#B66816',
      darker: '#793908',
      contrastText: '#FFFFFF',
    },
  },
  // RED
  {
    name: 'red',
    primary: {
      lighter: '#FFE3D5',
      light: '#FFC1AC',
      main: '#FF3030',
      dark: '#B71833',
      darker: '#7A0930',
      contrastText: '#FFFFFF',
    },
  },
];

// Function to get preset by name
export function getPreset(name) {
  return presets.find((preset) => preset.name === name) || presets[0];
}

// Function to create palette channel colors (for alpha usage)
export function createPaletteWithChannel(palette) {
  return Object.keys(palette).reduce((acc, color) => {
    const colors = {
      ...acc,
      [color]: palette[color],
    };

    // Add channel values for alpha operations
    if (color !== 'contrastText') {
      colors[`${color}Channel`] = alpha(palette[color], 1).substring(5).replace(')', '');
    }

    return colors;
  }, {});
}

// Function to apply color preset to theme
export function applyPreset(theme, preset) {
  const { primary } = getPreset(preset);
  
  return {
    ...theme,
    palette: {
      ...theme.palette,
      primary: createPaletteWithChannel(primary),
    },
  };
}